import React, { useEffect } from 'react'
import { Form } from 'react-bootstrap'
import InputField from '@components/common/InputField/InputField.component'
import { IContact } from '@dataTypes/contact.type'
import { stateToZip, USStates } from '@constants/Common/personalInfo.constants'

type AddressFieldsProps = {
  contact: IContact
  handleInputChange: (field: keyof IContact, value: string) => void
  validationErrors: { [key: string]: string }
}

const AddressFields: React.FC<AddressFieldsProps> = ({
  contact,
  handleInputChange,
  validationErrors,
}) => {
  // Auto-fill zip code when state changes
  useEffect(() => {
    if (contact.state && stateToZip[contact.state]) {
      handleInputChange('zip', stateToZip[contact.state])
    }
  }, [contact.state, handleInputChange])

  return (
    <>
      <div className="acm-row acm-row-3">
        <InputField
          label="Address"
          placeholder="Enter an Address"
          value={contact.address}
          onChange={(e) => handleInputChange('address', e.target.value)}
          hint={validationErrors.address || undefined}
          destructive={!!validationErrors.address}
        />
      </div>

      <div className="acm-row acm-row-4">
        <div className="city-slot">
          <InputField
            label="City"
            placeholder="Enter a City"
            value={contact.city || ''}
            onChange={(e) => handleInputChange('city', e.target.value)}
            hint={validationErrors.city || undefined}
            destructive={!!validationErrors.city}
          />
        </div>

        <div className="state-slot">
          <div className="acm-input-label">State</div>
          <Form.Select
            value={contact.state}
            onChange={(e) => handleInputChange('state', e.target.value)}
            className={validationErrors.state ? 'select-field-destructive' : ''}
          >
            <option value="">--</option>
            {USStates.map((state) => (
              <option key={state.value} value={state.value}>
                {state.label}
              </option>
            ))}
          </Form.Select>
          {validationErrors.state && (
            <div className="text-danger">{validationErrors.state}</div>
          )}
        </div>

        <div className="zip-slot">
          <InputField
            label="Zip"
            value={contact.zip || ''}
            onChange={(e) => handleInputChange('zip', e.target.value)}
            hint={validationErrors.zip || undefined}
            destructive={!!validationErrors.zip}
          />
        </div>
      </div>
    </>
  )
}

export default AddressFields
